import React, { useState } from "react";
import List from "../../common/List/List";
import TitleCell from "../../common/List/TitleCell";
import uniqid from "uniqid";
import Row from "../../common/List/Row";
import { isoToFormatDate } from "../../../functions/formatTime";
import {
  Flex,
  FormLabel,
  HStack,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import ChakraPopUp from "../../common/PopUp/ChakraPopUp";
import { fetchWithToken } from "../../../functions/fetch";
import { useQueryClient } from "@tanstack/react-query";
import { useFormik } from "formik";
import { postTemplateMessageSchema } from "../../../validation/messageValidation";
import FormikInput from "../../common/PopUp/ChakraFormik/FormikInput";
import ErrorMessages from "../../common/PopUp/ChakraFormik/ErrorMessages";

const TemplateMessageList = ({ templateMessages }) => {
  const titles = ["公版標題", "公版內容", "修改時間"];
  const queryClient = useQueryClient();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentTemplateMessage, setCurrentTemplateMessage] = useState(null);

  const deleteTemplateMessage = async () => {
    setIsSubmitting(true);
    const res = await fetchWithToken(
      "DELETE",
      `${process.env.REACT_APP_BACKEND_HOST}/api/template-message/${currentTemplateMessage._id}`,
    );
    if (res.status === 200) {
      queryClient.invalidateQueries({ queryKey: ["templateMessages"] });
      onClose();
    } else {
      console.error(res);
    }
    setIsSubmitting(false);
  };

  const formik = useFormik({
    initialValues: {
      title: currentTemplateMessage?.title,
      text: currentTemplateMessage?.text,
    },
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true);
      const res = await fetchWithToken(
        "PUT",
        `${process.env.REACT_APP_BACKEND_HOST}/api/template-message/${currentTemplateMessage._id}`,
        values,
      );
      if (res.status === 200) {
        queryClient.invalidateQueries({ queryKey: ["templateMessages"] });
        resetForm();
        onClose();
      } else {
        console.error(res);
      }
      setIsSubmitting(false);
    },
    enableReinitialize: true,
    validationSchema: postTemplateMessageSchema,
  });

  const cellAlign = ["L"];

  return (
    <div>
      {/* Update/delete pop up */}
      <ChakraPopUp
        isOpen={isOpen}
        onOpen={onOpen}
        isSubmitting={isSubmitting}
        onClose={onClose}
        onSubmit={formik.handleSubmit}
        title="編輯公版訊息"
        hasDeleteButton
        deleteFunction={deleteTemplateMessage}
      >
        <Flex direction="column" gap={4}>
          <FormikInput formik={formik} field="title" labelText="公版標題" />
          <HStack>
            <FormLabel
              mb={0}
              whiteSpace="nowrap"
              alignSelf="start"
              htmlFor="text"
            >
              公版內容
            </FormLabel>
            <Textarea
              {...formik.getFieldProps("text")}
              variant="filled"
              id="text"
            />
          </HStack>
          <ErrorMessages formik={formik} />
        </Flex>
      </ChakraPopUp>

      <List gridCols="grid-cols-[minmax(min-content,1fr)_3fr_min-content]">
        {titles.map((title) => (
          <TitleCell
            key={uniqid()}
            className="whitespace-nowrap px-2 overflow-x-auto"
            text={title}
          />
        ))}
        {templateMessages.map((tm) => {
          const { title, text, updatedAt } = tm;
          const cellTexts = [title];

          const noteTexts = [
            text,
            isoToFormatDate(updatedAt, "yyyy/MM/dd HH:mm"),
          ];

          return (
            <Row
              key={uniqid()}
              cellTexts={cellTexts}
              noteTexts={noteTexts}
              showPopUp={() => {
                onOpen();
                setCurrentTemplateMessage(tm);
              }}
              cellAlign={cellAlign}
            />
          );
        })}
      </List>
    </div>
  );
};

export default TemplateMessageList;
